import React, { useState } from 'react';
import Course from './Course';

const AllCourse = () => {

    const [courses, setCourses] = useState([
        {title:"Java Course", description:"This a Java Course for Beginners."},
        {title:"WebDev Course", description:"This a WebDev Course for Beginners."},
        {title:"Hacking Course", description:"This a Hacking Course for Beginners."},
        {title:"Angular Course", description:"This a Angular Course for Beginners."},
    ]);

    return (
        <div>
            <h1>All Courses</h1>
            <p className='fw-bold'>Here are all the available courses.</p>

            {   
                courses.length > 0 ? courses.map((item) => <Course course={item} /> ) : "No Courses"
            }

            <br/>

        </div>
    );
}

export default AllCourse;